// Copyright 2019 Sorama B.V.

export class SortValueConverter {
    toView(value: unknown[], propertyName: string): unknown[] {
        if (!value) return [];

        return value.slice(0).sort((a, b) => {
            return a[propertyName] - b[propertyName];
        });
    }
}
